import React, { useState } from "react";

const TacticalIcon = ({ type, color }) => {
    // Generates a custom high-tech SVG icon instead of generic emojis
    return (
        <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="10" y="10" width="40" height="40" stroke={color} strokeWidth="1" strokeOpacity="0.3" />
            <path d="M5 5L15 5M5 5L5 15" stroke={color} strokeWidth="2" />
            <path d="M55 55L45 55M55 55L55 45" stroke={color} strokeWidth="2" />
            {type === '📡' && <path d="M30 20V40M20 30H40" stroke={color} strokeWidth="2" strokeLinecap="round" />}
            {type === '🛡️' && <path d="M30 15L45 22V35C45 45 30 50 30 50C30 50 15 45 15 35V22L30 15Z" stroke={color} strokeWidth="2" />}
            {type === '👁️' && <circle cx="30" cy="30" r="10" stroke={color} strokeWidth="2" />}
            {type === '🚨' && <rect x="25" y="15" width="10" height="30" rx="5" fill={color} fillOpacity="0.5" />}
            {type === '🕵️' && <path d="M20 45C20 40 25 35 30 35C35 35 40 40 40 45" stroke={color} strokeWidth="2" />}
            <circle cx="30" cy="30" r="2" fill={color} />
        </svg>
    );
};

function About({ content }) {
  const [hovered, setHovered] = useState(null);
  const { features, color, atmosphere } = content;

  return (
    <section id="features" style={{
      padding: "160px 30px", background: "#010108", position: "relative", overflow: "hidden"
    }}>
      <style>{`
        @keyframes scanMove { 0% { top: 0; } 100% { top: 100%; } }
        @keyframes cornerPulse { 0% { opacity: 0.3; } 100% { opacity: 1; } }
        .tech-card:hover { border-color: ${color} !important; background: ${color}05 !important; }
        .tech-card:hover .scanline { display: block; }
        .tech-card:hover .tech-details { opacity: 0.6 !important; }
      `}</style>
      
      {/* Background Ambience */}
      <div style={{
          position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)",
          width: "1200px", height: "1200px", background: `radial-gradient(circle, ${color}03 0%, transparent 70%)`,
          zIndex: 0
      }} />

      <div style={{ maxWidth: "1400px", margin: "0 auto", position: "relative", zIndex: 1 }}>
        <div style={{ textAlign: "center", marginBottom: "120px" }}>
          <div style={{ 
              display: "inline-block", padding: "8px 20px", border: `1px solid ${color}30`, 
              color: color, fontSize: "11px", fontFamily: "monospace", letterSpacing: "5px",
              marginBottom: "30px", background: "rgba(0,0,0,0.5)"
          }}>SUB_SYSTEM_CAPABILITIES</div>
          
          <h2 style={{
            fontSize: "clamp(35px, 5vw, 65px)", fontFamily: "'Conthrax', sans-serif",
            color: "#fff", lineHeight: 1, textTransform: "uppercase"
          }}>
            Strategic <br />
            <span style={{ color: color }}>Intelligence Assets</span>
          </h2>
          <p style={{ color: "rgba(255,255,255,0.3)", maxWidth: "600px", margin: "25px auto", fontFamily: "monospace", fontSize: "12px" }}>
            >> REAL-TIME SENSOR INTEGRATION FOR {atmosphere} PROTOCOLS...
          </p>
        </div>

        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(400px, 1fr))", gap: "2px", background: "rgba(255,255,255,0.05)" }}>
          {features.map((f, i) => (
            <div
              key={i}
              className="tech-card"
              onMouseEnter={() => setHovered(i)}
              onMouseLeave={() => setHovered(null)}
              style={{
                background: "#010108", padding: "60px 50px", transition: "all 0.4s",
                position: "relative", overflow: "hidden", display: "flex", flexDirection: "column", gap: "30px"
              }}
            >
              {/* Animated Scanline on Hover */}
              <div className="scanline" style={{
                  display: "none", position: "absolute", left: 0, width: "100%", height: "2px",
                  background: `linear-gradient(90deg, transparent, ${color}, transparent)`,
                  animation: "scanMove 2s linear infinite", zIndex: 2
              }} />

              {/* Technical Data Overlay (Hover Only) */}
              <div className="tech-details" style={{
                  position: "absolute", top: "15px", right: "20px", fontSize: "8px",
                  color: color, opacity: 0, transition: "opacity 0.3s", fontFamily: "monospace",
                  textAlign: "right", lineHeight: 1.5
              }}>
                  ID_{Math.floor(Math.random()*99999)}<br />
                  LATENCY_0.02ms<br />
                  ENCRYPT_TLS_1.3
              </div>

              <div style={{ position: "relative" }}>
                 <TacticalIcon type={f.icon} color={color} />
                 {/* Corner Decoration */}
                 <div style={{ 
                     position: "absolute", top: -10, left: -10, width: "20px", height: "20px", 
                     borderTop: `2px solid ${color}`, borderLeft: `2px solid ${color}`,
                     opacity: hovered === i ? 1 : 0.2, transition: "opacity 0.3s"
                 }} />
              </div>
              
              <div>
                  <h5 style={{ 
                      fontSize: "20px", fontFamily: "'Conthrax', sans-serif", 
                      color: "#fff", marginBottom: "15px", letterSpacing: "1px" 
                  }}>{f.title.toUpperCase()}</h5>
                  <p style={{ 
                      fontSize: "15px", color: "rgba(255,255,255,0.4)", 
                      lineHeight: 1.8, fontFamily: "'Readex Pro', sans-serif", fontWeight: "300"
                  }}>
                      {f.desc}
                  </p>
              </div>

              <div style={{ 
                  marginTop: "auto", display: "flex", alignItems: "center", gap: "10px",
                  fontSize: "10px", color: color, fontFamily: "monospace", opacity: 0.6
              }}>
                  <div style={{ width: "30px", height: "1px", background: color }} />
                  ANALYSIS_STATUS: OPTIMAL
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default About;